export default class TopicCategory extends String{
  static readonly LegalEntities = {
    EntityMember: 'LegalEntities.EntityMember',
    EntityMemberInvitation: 'LegalEntities.EntityMemberInvitation',
    LegalEntity: 'LegalEntities.LegalEntity',
    // A firm's own roster of colleagues, asked for once its Attorney Hub proposal is hired. The
    // topic id is the firm, not a record of the request: there is no roster row to open, only the
    // page where the roster is entered.
    TeamRoster: 'LegalEntities.TeamRoster'
  };
  static readonly Marketplace = {
    Team: 'Marketplace.Team',
    TeamInvitation: 'Marketplace.TeamInvitation'
  };
  static readonly Messaging = {
    Forum: 'Messaging.Forum',
    ForumInvitation: 'Messaging.ForumInvitation'
  };
  static readonly Users = {
    NetworkInvitation: 'Users.NetworkInvitation',
    NetworkConnection: 'Users.NetworkConnection'
  };
  static readonly Work = {
    Proposal: 'Work.Proposal',
    Agreement: 'Work.Agreement'
  };
}
